__webpack_require__.p = "/Resto/";